// 证件类型
export function identityType(code) {
  let title;
  code == 1 && (title = "身份证");
  code == 2 && (title = "户口本");
  code == 3 && (title = "出生证明");
  code == 4 && (title = "护照");
  code == 5 && (title = "港澳往来大陆通行证");
  code == 6 && (title = "台湾往来大陆通行证");
  return title;
}

// 性别
export function gender(code) {
  let title;
  switch (code) {
    case "M":
      title = "男";
      break;
    case "男":
      title = "男";
      break;
    case "F":
      title = "女";
      break;
    case "女":
      title = "女";
      break;
  }
  return title;
}

//关系
export function relation(code) {
  console.log(code, "codecodecode");
  let title;
  code == 1 && (title = "本人");
  code == 2 && (title = "丈夫");
  code == 3 && (title = "妻子");
  code == 4 && (title = "父亲");
  code == 5 && (title = "母亲");
  code == 6 && (title = "儿子");
  code == 7 && (title = "女儿");
  code == 8 && (title = "祖父");
  code == 9 && (title = "祖母");
  code == 10 && (title = "外祖父");
  code == 11 && (title = "外祖母");
  code == 12 && (title = "孙子");
  code == 13 && (title = "孙女");
  code == 14 && (title = "外孙");
  code == 15 && (title = "外孙女");
  code == 16 && (title = "其他");
  return title;
}
